import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultLauncherComponent } from './default-launcher/default-launcher.component';
import { GlobalComponentsModule } from '../global-components.module';
import { IbexIconModule } from '@ibexfusion/ibex-icon';
import { CarouselModule } from '../carousel/carousel.module';
import { PipesModule } from '../../pipes/pipes.module';
import { WidgetsComponentModule } from '../widgets/widgets-component.module';
import { InfoscreenLauncherComponent } from './infoscreen-launcher/infoscreen-launcher.component';
import { DefaultLauncherHeaderComponent } from './default-launcher/default-launcher-header/default-launcher-header.component';
import { HybridLauncherComponent } from './hybrid-launcher/hybrid-launcher.component';
import { WidgetCarouselModule } from '../widget-carousel/widget-carousel.module';
import { PagesLauncherComponent } from './pages-launcher/pages-launcher.component';
import {RouterModule} from "@angular/router";

@NgModule({
  imports: [CommonModule, GlobalComponentsModule, IbexIconModule,
      CarouselModule, WidgetCarouselModule, PipesModule, WidgetsComponentModule, RouterModule],
  exports: [DefaultLauncherComponent, DefaultLauncherHeaderComponent, InfoscreenLauncherComponent,
      HybridLauncherComponent, PagesLauncherComponent],
  declarations: [DefaultLauncherComponent, DefaultLauncherHeaderComponent,
      InfoscreenLauncherComponent, HybridLauncherComponent, PagesLauncherComponent]
})
export class LaunchersModule {
}
